import Alpine from 'alpinejs'

const data = (params = {}) => ({
  text: '',
  showTooltip: false,

  init() {
    if (!this.text) { return }

    let timer = null
    this.$root.addEventListener('click', async () => {
      await navigator.clipboard.writeText(this.text)

      if (timer) clearTimeout(timer);
      this.showTooltip = true;
      timer = setTimeout(() => { this.showTooltip = false }, 2000);
    })
  },

  ...params
})

Alpine.data('copy', data)

export default data
